import * as constants from '../../constants';
import sectionBody from '../../shared-ui/section-body';
import * as progressDialog from './progress-dialog';
import * as last5 from './last5';
import * as exitButton from './exit-button';
import * as exitModal from './exit-modal';
import * as progressButtons from './progress-buttons';

export const testScreen = new PIXI.Container();
testScreen.visible = false;

export const toolContainer = new PIXI.Container();

const headerBg = new PIXI.Graphics();
headerBg
.clear()
.beginFill(constants.lightBlue)
.drawRect(0, 0, constants.screenWidth, constants.headerHeight)
.endFill();

const bodyBg = sectionBody(constants.screenBodyHeight);
bodyBg.position.set(0, constants.headerHeight);

toolContainer.position.set(0, constants.headerHeight);

// header
testScreen.addChild(headerBg);
testScreen.addChild(bodyBg);
testScreen.addChild(progressDialog.sprite);
testScreen.addChild(last5.sprite);
testScreen.addChild(exitButton.sprite);
// body
testScreen.addChild(toolContainer);
testScreen.addChild(progressButtons.sprite);
// modals
testScreen.addChild(exitModal.sprite);

// header positioning
progressDialog.sprite.position.set(17, 12);
last5.sprite.position.set(220, 8);
exitButton.sprite.x = constants.screenWidth - exitButton.width;

progressButtons.sprite.position.set(constants.screenWidth / 2, constants.headerHeight + constants.toolHeight);

exitButton.setShowExitModal(exitModal.showModal);
